import { TableRow, TableCell, SxProps, Theme, IconButton } from '@mui/material';
import { useCallback } from 'react';
import { NumberText } from 'quote-detail/number-text';
import { useQuoteState } from 'shared/contexts';
import { ProductRecommendationLookup } from 'shared/types';
import { AddCircleOutline, CheckCircle } from '@mui/icons-material';

const containerStyles: SxProps<Theme> = (theme: Theme) => ({
  cursor: 'pointer',
  '& .MuiTableCell-body': {
    '&:first-of-type': {
      paddingLeft: theme.spacing(5),
    },
  },
});

interface IProductRecommendationsProps {
  productRecommendation: ProductRecommendationLookup;
}

export function ProductRecommendationsSummary({ productRecommendation }: IProductRecommendationsProps) {
  const { editMode, recommendationsSelected, setRecommendationsSelected } = useQuoteState();

  const handleChange = useCallback(() => {
    if (recommendationsSelected.every(r => r.uniqueid !== productRecommendation.uniqueid)) {
      setRecommendationsSelected(prevState => [...prevState, productRecommendation]);
    } else {
      setRecommendationsSelected(prevState => {
        const newRecommendations = [...prevState];
        newRecommendations.splice(
          prevState.findIndex(p => p.uniqueid === productRecommendation.uniqueid),
          1
        );
        return newRecommendations;
      });
    }
  }, [setRecommendationsSelected, productRecommendation, recommendationsSelected]);

  return (
    <>
      <TableRow sx={containerStyles}>
        {editMode && (
          <TableCell align='left'>
            <IconButton onClick={handleChange}>
              {recommendationsSelected.some(r => r.uniqueid === productRecommendation.uniqueid) ? (
                <CheckCircle color='success' />
              ) : (
                <AddCircleOutline color='primary' />
              )}
            </IconButton>
          </TableCell>
        )}
        <TableCell align='left'>{productRecommendation.itemdescription}</TableCell>
        <TableCell align='left'>{productRecommendation.itemid}</TableCell>
        <TableCell align='left'>{productRecommendation.lastpurchasedate}</TableCell>
        <TableCell align='left'>
          <NumberText prefix='$' fixedDecimalScale decimalScale={2} text={productRecommendation.cost} />
        </TableCell>
        <TableCell align='left'>
          <NumberText prefix='$' fixedDecimalScale decimalScale={2} text={productRecommendation.customertiersalesttm} />
        </TableCell>
        <TableCell align='left'>{productRecommendation.reason}</TableCell>
        <TableCell align='right'></TableCell>
      </TableRow>
    </>
  );
}
